(function () {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const defaultStorageKey = 'handoveraBookingDraft';
  const maxQuestionnairePayloadBytes = 4500000;
  let storageKey = defaultStorageKey;

  const readJson = (selector) => {
    const node = qs(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (error) { return null; }
  };

  const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[char]));

  const getParam = (key) => new URLSearchParams(window.location.search).get(key);
  const normalPackage = (value) => String(value || 'premium').toLowerCase().replace(/[^a-z]/g, '');
  const syncModalBody = () => {
    const hasOpenModal = qsa('.hnd-modal.is-open').some((modal) => !modal.hidden);
    document.body.classList.toggle('hnd-modal-open', hasOpenModal);
  };
  const showModal = (modal) => {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      syncModalBody();
    });
  };
  const hideModal = (modal, beforeClose) => {
    if (!modal || modal.hidden) return;
    if (typeof beforeClose === 'function') beforeClose();
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      modal.hidden = true;
      syncModalBody();
    }, 430);
  };

  qsa('[data-hnd-menu-toggle]').forEach((toggle) => {
    const nav = qs(`#${toggle.getAttribute('aria-controls')}`);
    if (!nav) return;
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      nav.classList.toggle('is-open', !isOpen);
    });
    qsa('a', nav).forEach((link) => link.addEventListener('click', () => {
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    }));
  });

  const header = qs('.hnd-header');
  const syncHeader = () => {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  qsa('.hnd-section, .hnd-page-hero, .hnd-final, .hnd-cta-strip, .hnd-footer, .hnd-card, .hnd-package-card, .hnd-project-card')
    .forEach((node) => node.classList.add('is-visible'));

  const initialiseCalendlyWidgets = () => {
    const widgets = qsa('.hnv-calendly-inline[data-url], .hnv-calendly-inline[data-hnv-calendly-url]');
    if (!widgets.length) return;

    const initialise = () => {
      if (!window.Calendly) return;
      widgets.forEach((widget) => {
        if (widget.dataset.hnvCalendlyReady === 'true') return;
        widget.dataset.hnvCalendlyReady = 'true';
        window.Calendly.initInlineWidget({
          url: widget.dataset.hnvCalendlyUrl || widget.dataset.url || '',
          parentElement: widget
        });
      });
    };

    if (window.Calendly) {
      initialise();
      return;
    }

    const src = 'https://assets.calendly.com/assets/external/widget.js';
    const existing = qsa('script[src]').find((script) => script.src === src);
    if (existing) {
      existing.addEventListener('load', initialise, { once: true });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.hndCalendlyWidget = 'true';
    script.addEventListener('load', initialise, { once: true });
    document.head.appendChild(script);
  };

  initialiseCalendlyWidgets();

  const consultationFlow = qs('[data-hnv-consultation-flow]');
  const unlockProjectBrief = () => {
    qsa('[data-hnv-brief-gate]').forEach((gate) => {
      gate.classList.add('is-unlocked');
      const status = qs('[data-hnv-brief-status]', gate);
      if (status) status.textContent = gate.dataset.hnvBriefUnlocked || status.textContent;
    });
    qsa('[data-hnd-booking-after-calendly]').forEach((button) => {
      button.disabled = false;
      button.setAttribute('aria-disabled', 'false');
    });
  };

  if (consultationFlow) {
    unlockProjectBrief();
    window.addEventListener('message', (event) => {
      if (!/^https:\/\/(?:[\w-]+\.)?calendly\.com$/.test(event.origin)) return;
      const payload = event.data || {};
      if (payload.event !== 'calendly.event_scheduled') return;
      unlockProjectBrief();
    });
  }

 qsa('[data-hnd-compare]').forEach((wrap) => {
    const input = qs('[data-hnd-compare-input]', wrap);
    const setCompareWidth = () => {
      const width = wrap.getBoundingClientRect().width;
      if (width > 0) wrap.style.setProperty('--compare-width', `${width}px`);
    };
    const setValue = (value) => {
      setCompareWidth();
      wrap.style.setProperty('--position', `${value}%`);
    };
    if (!input) return;
    setValue(input.value || 50);
    input.addEventListener('input', () => setValue(input.value));
    if ('ResizeObserver' in window) {
      new ResizeObserver(setCompareWidth).observe(wrap);
    } else {
      window.addEventListener('resize', setCompareWidth);
    }
  });

  qsa('[data-hnd-ba-gallery]').forEach((gallery) => {
    const tabs = qsa('[data-hnd-ba-tab]', gallery);
    const panels = qsa('[data-hnd-ba-panel]', gallery);
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      const target = tab.dataset.target;
      tabs.forEach((item) => {
        const active = item.dataset.target === target;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      panels.forEach((panel) => {
        const active = panel.dataset.hndBaPanel === target;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
        if (active) {
          const input = qs('[data-hnd-compare-input]', panel);
          const compare = qs('[data-hnd-compare]', panel);
          if (input && compare) {
            window.requestAnimationFrame(() => {
              const width = compare.getBoundingClientRect().width;
              if (width > 0) compare.style.setProperty('--compare-width', `${width}px`);
              compare.style.setProperty('--position', `${input.value || 50}%`);
            });
          }
        }
      });
    }));
  });

  qsa('[data-hnd-package-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const card = button.closest('[data-hnd-package-card]');
      if (!card) return;
      const isOpen = card.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(isOpen));
      button.textContent = isOpen ? (button.dataset.closeLabel || 'Hide inclusions') : (button.dataset.openLabel || button.dataset.label || button.textContent);
    });
    button.dataset.label = button.textContent;
  });

  qsa('[data-hnd-currency-converter]').forEach((wrap) => {
    const amountInput = qs('[data-hnd-currency-amount]', wrap);
    const targetSelect = qs('[data-hnd-currency-target]', wrap);
    const output = qs('[data-hnd-currency-output]', wrap);
    if (!amountInput || !targetSelect || !output) return;
    let rates = { EUR: 0.245, USD: 0.272, GBP: 0.209 };
    try {
      rates = { ...rates, ...JSON.parse(wrap.dataset.rates || '{}') };
    } catch (error) {}

    const formatCurrency = (code, value) => {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: code,
          maximumFractionDigits: 0
        }).format(value);
      } catch (error) {
        return `${code} ${Math.round(value).toLocaleString()}`;
      }
    };

    const syncCurrency = () => {
      const amount = Number(String(amountInput.value || '').replace(/,/g, '')) || 0;
      const target = targetSelect.value || 'EUR';
      const rate = Number(rates[target]) || 0;
      output.textContent = formatCurrency(target, amount * rate);
    };

    amountInput.addEventListener('input', syncCurrency);
    targetSelect.addEventListener('change', syncCurrency);
    syncCurrency();
  });

  qsa('[data-hnd-compare-table]').forEach((section) => {
    const more = qs('[data-hnd-compare-more]', section);
    const syncColumns = () => {
      qsa('[data-hnd-compare-col]', section).forEach((input) => {
        const col = input.dataset.hndCompareCol;
        qsa(`[data-hnd-col="${col}"]`, section).forEach((cell) => {
          cell.hidden = !input.checked;
        });
      });
    };
    qsa('[data-hnd-compare-col]', section).forEach((input) => input.addEventListener('change', syncColumns));
    if (more) {
      more.addEventListener('click', () => {
        const isOpen = section.classList.toggle('is-expanded');
        const label = qs('[data-hnd-compare-more-label]', more);
        if (label) {
          label.textContent = isOpen ? (more.dataset.closeLabel || 'Show less') : (more.dataset.openLabel || 'See more');
        } else {
          more.textContent = isOpen ? (more.dataset.closeLabel || 'Show less') : (more.dataset.openLabel || 'See more');
        }
        more.classList.toggle('is-open', isOpen);
      });
    }
    syncColumns();
  });

  const processModal = qs('[data-hnd-process-modal]');
  const openProcess = (trigger) => {
    if (!processModal || !trigger) return;
    const title = qs('[data-hnd-process-title]', processModal);
    const text = qs('[data-hnd-process-text]', processModal);
    const media = qs('[data-hnd-process-media]', processModal);
    const images = String(trigger.dataset.images || '').split('|').filter(Boolean);
    if (title) title.textContent = trigger.dataset.title || '';
    if (text) text.textContent = trigger.dataset.text || '';
    if (media) {
      media.innerHTML = images.length
        ? images.map((src, index) => `<img src="${esc(src)}" alt="${esc(trigger.dataset.title || 'Handovera process preview')} ${index + 1}" loading="lazy">`).join('')
        : '<div class="hnd-process-modal__empty">Add preview images in the theme editor.</div>';
    }
    showModal(processModal);
  };
  qsa('[data-hnd-process-open]').forEach((step) => {
    step.addEventListener('click', () => openProcess(step));
    step.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openProcess(step);
      }
    });
  });
  if (processModal) {
    qsa('[data-hnd-process-close]', processModal).forEach((button) => button.addEventListener('click', () => hideModal(processModal)));
    processModal.addEventListener('click', (event) => {
      if (event.target === processModal) hideModal(processModal);
    });
  }

  const projectModal = qs('[data-hnd-project-modal]');
  const openProject = (trigger) => {
    if (!projectModal || !trigger) return;
    const title = qs('[data-hnd-project-title]', projectModal);
    const meta = qs('[data-hnd-project-meta]', projectModal);
    const text = qs('[data-hnd-project-text]', projectModal);
    const media = qs('[data-hnd-project-media]', projectModal);
    const inclusions = qs('[data-hnd-project-inclusions]', projectModal);
    const images = String(trigger.dataset.images || '').split('|').filter(Boolean);
    if (title) title.textContent = trigger.dataset.title || '';
    if (meta) meta.textContent = trigger.dataset.meta || '';
    if (text) text.textContent = trigger.dataset.text || '';
    if (media) media.innerHTML = images.map((src, index) => `<img src="${esc(src)}" alt="${esc(trigger.dataset.title || 'Handovera project')} ${index + 1}" loading="lazy">`).join('');
    if (inclusions) {
      const rows = String(trigger.dataset.inclusions || '').split(/\n+/).map((line) => line.trim()).filter(Boolean);
      inclusions.innerHTML = rows.length ? `<h4>Included in this project</h4><ul>${rows.map((row) => `<li>${esc(row)}</li>`).join('')}</ul>` : '';
    }
    showModal(projectModal);
  };
  qsa('[data-hnd-project-open]').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('input')) return;
      openProject(card);
    });
    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openProject(card);
      }
    });
    card.setAttribute('tabindex', '0');
    card.setAttribute('role', 'button');
  });
  if (projectModal) {
    qsa('[data-hnd-project-close]', projectModal).forEach((button) => button.addEventListener('click', () => hideModal(projectModal)));
    projectModal.addEventListener('click', (event) => {
      if (event.target === projectModal) hideModal(projectModal);
    });
  }

  const packageTabs = qsa('[data-hnd-package-tab]');
  const setSelectedPackage = (pkg) => {
    const selected = normalPackage(pkg);
    window.handoveraSelectedPackage = selected;
    packageTabs.forEach((tab) => {
      const active = normalPackage(tab.dataset.package) === selected;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try { localStorage.setItem('handoveraSelectedPackage', selected); } catch (error) {}
  };
  const readStoredPackage = () => {
    try { return localStorage.getItem('handoveraSelectedPackage'); } catch (error) { return ''; }
  };
  const initialPackage = normalPackage(getParam('package') || readStoredPackage() || 'premium');
  setSelectedPackage(initialPackage);
  packageTabs.forEach((tab) => tab.addEventListener('click', () => setSelectedPackage(tab.dataset.package)));

  const bookingModal = qs('[data-hnd-booking-modal]');
  const bookingPrimyHost = bookingModal ? qs('[data-hnd-booking-primy-host]', bookingModal) : null;
  const hasPrimyBookingForm = Boolean(bookingPrimyHost);
  const compactBookingUploadFrame = (frame) => {
    try {
      const doc = frame.contentDocument;
      if (!doc || doc.getElementById('HandoveraBookingUploadFrameStyles')) return;

      const style = doc.createElement('style');
      style.id = 'HandoveraBookingUploadFrameStyles';
      style.textContent = `
        .hnd-header,
        .hnd-page-hero,
        .hnd-lux-footer,
        [data-hnd-booking-modal],
        [data-hnd-network-modal] {
          display: none !important;
        }

        #MainContent {
          min-height: 0 !important;
        }

        .hnv-primy-host {
          padding: 0 !important;
        }

        .hnv-primy-host__layout {
          display: block !important;
          width: 100% !important;
        }

        .hnv-primy-host__content {
          display: none !important;
        }

        .hnv-primy-host__app {
          border: 0 !important;
          box-shadow: none !important;
          padding: 0 !important;
        }
      `;
      doc.head.appendChild(style);

      const resize = () => {
        const pageHeight = Math.max(doc.documentElement.scrollHeight, doc.body ? doc.body.scrollHeight : 0, 700);
        frame.style.height = `${Math.min(pageHeight + 24, 1100)}px`;
      };

      resize();
      window.setTimeout(resize, 1000);
    } catch (error) {
      // The dedicated upload page remains available if the embedded frame cannot be compacted.
    }
  };

  if (bookingModal) {
    qsa('[data-hnd-booking-upload-frame]', bookingModal).forEach((frame) => {
      frame.addEventListener('load', () => compactBookingUploadFrame(frame));
      if (frame.contentDocument && frame.contentDocument.readyState === 'complete') compactBookingUploadFrame(frame);
    });
  }
  const packageData = readJson('[data-hnd-package-data]') || {};
  const wishlistRoot = readJson('[data-hnd-wishlist-data]') || { wishlist: {} };
  const wishlistData = wishlistRoot.wishlist || {};
  const bookingConfig = readJson('[data-hnd-booking-config]') || {};
  const bookingLabels = bookingConfig.labels || {};
  const bLabel = (key, fallback) => bookingLabels[key] || fallback;

  const groupItems = (items) => items.reduce((acc, item) => {
    const category = item.category || 'Project';
    if (!acc[category]) acc[category] = [];
    acc[category].push(item);
    return acc;
  }, {});

  const safeId = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  const projectStorageKey = (projectId) => {
    const key = safeId(projectId);
    return key ? `${defaultStorageKey}:${key}` : defaultStorageKey;
  };

  const loadDraft = () => {
    try { return JSON.parse(localStorage.getItem(storageKey)) || {}; } catch (error) { return {}; }
  };
  const saveDraft = (state) => {
    try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (error) {}
  };

  const bookingState = Object.assign({
    step: 0,
    selected_package: initialPackage,
    selected_date: '',
    selected_time: '',
    timezone: bookingModal ? bookingModal.dataset.timezone : '',
    personal_details: {},
    apartment_details: {},
    uploads_metadata: [],
    wishlist_by_category: {},
    tracking_data: {}
  }, loadDraft());
  bookingState.selected_package = normalPackage(getParam('package') || bookingState.selected_package || initialPackage);
  const bookingRuntime = {
    projectId: '',
    customerId: '',
    customerEmail: '',
    makeWebhook: ''
  };

  const setStatus = (text) => {
    const node = qs('[data-hnd-booking-status]', bookingModal);
    if (node) node.textContent = text || '';
  };

  const packageCardHtml = (key) => {
    const pkg = packageData[key] || packageData.premium || {};
    const inclusions = (pkg.inclusions || []).slice(0, 4).map((item) => `<li>${esc(item)}</li>`).join('');
    return `<button type="button" class="hnd-modal-package ${bookingState.selected_package === key ? 'is-active' : ''}" data-hnd-modal-package="${key}">
      <span>${esc(pkg.badge || '')}</span><strong>${esc(pkg.name || key)}</strong><em>${esc(pkg.price || '')}</em><small>${esc(pkg.best_for || '')}</small><ul>${inclusions}</ul>
    </button>`;
  };

  const parseConfiguredFields = (text, fallback) => {
    const lines = String(text || '').split(/\n+/).map((line) => line.trim()).filter(Boolean);
    const source = lines.length ? lines : fallback;
    return source.map((line) => {
      if (typeof line === 'object') return line;
      const parts = String(line).split('|').map((part) => part.trim());
      return {
        name: safeId(parts[0] || parts[1] || 'field'),
        label: parts[1] || parts[0] || 'Field',
        type: parts[2] || 'text',
        required: String(parts[3] || '').toLowerCase() === 'required',
        options: (parts[4] || '').split(',').map((option) => option.trim()).filter(Boolean)
      };
    });
  };

  const personalFallback = [
    'first_name|First name|text|required|',
    'last_name|Last name|text|required|',
    'email|Email|email|required|',
    'whatsapp|WhatsApp number|tel|required|',
    'country_of_residence|Country of residence|text||',
    'preferred_language|Preferred language|select||English,Dutch,Arabic,Other'
  ];
  const apartmentFallback = [
    'community|Apartment community|text|required|',
    'building_name|Building name|text|required|',
    'unit_number|Unit number optional|text||',
    'apartment_type|Apartment type|select||Studio,1 bedroom,2 bedroom,3 bedroom,Penthouse,Villa,Other',
    'bedrooms|Bedrooms|text||',
    'approximate_size|Approximate size|text||',
    'handover_completed|Handover completed|select||Yes,No,Soon',
    'keys_available|Keys available|select||Yes,No,Soon',
    'current_status|Current apartment status|text||',
    'rental_goal|Rental goal|text||',
    'rental_type|Short-term or long-term rental|select||Short-term rental,Long-term rental,Move-in ready,Not sure',
    'target_completion_date|Target completion date|date||',
    'budget_range|Budget range|text||',
    'main_concern|Main concern|text||',
    'notes|Notes|textarea||'
  ];
  const uploadFallback = [
    'apartment_photos|Apartment photos|multiple|',
    'floorplan|Floorplan||',
    'moodboard|Moodboard|multiple|',
    'snagging_report|Current snagging report optional||',
    'handover_document|Developer handover document optional||'
  ];

  const field = (group, name, label, type = 'text', required = false, options = []) => {
    const value = bookingState[group] && bookingState[group][name] ? bookingState[group][name] : '';
    if (options.length) {
      return `<label>${esc(label)}<select data-hnd-field="${group}.${name}" ${required ? 'required' : ''}><option value="">Select</option>${options.map((option) => `<option value="${esc(option)}" ${value === option ? 'selected' : ''}>${esc(option)}</option>`).join('')}</select></label>`;
    }
    if (type === 'textarea') return `<label class="hnd-field-full">${esc(label)}<textarea data-hnd-field="${group}.${name}" rows="4" maxlength="2000" ${required ? 'required' : ''}>${esc(value)}</textarea></label>`;
    const maxLength = type === 'email' ? 254 : type === 'tel' ? 32 : type === 'date' ? '' : 200;
    return `<label>${esc(label)}<input data-hnd-field="${group}.${name}" type="${type}" value="${esc(value)}" ${maxLength ? `maxlength="${maxLength}"` : ''} ${required ? 'required' : ''}></label>`;
  };

  const detailsHtml = () => {
    const personal = parseConfiguredFields(bookingConfig.personal_fields, personalFallback);
    const apartment = parseConfiguredFields(bookingConfig.apartment_fields, apartmentFallback);
    const projectReference = bookingRuntime.projectId
      ? `<p class="hnd-note hnd-note--project-reference"><strong>Project ID:</strong> ${esc(bookingRuntime.projectId)}</p>`
      : '';
    return `${projectReference}<div class="hnd-modal-field-group"><h3>Personal details</h3><div class="hnd-fields">${personal.map((item) => field('personal_details', item.name, item.label, item.type, item.required, item.options)).join('')}</div></div>
    <div class="hnd-modal-field-group"><h3>Apartment details</h3><div class="hnd-fields">${apartment.map((item) => field('apartment_details', item.name, item.label, item.type, item.required, item.options)).join('')}</div></div>`;
  };

  const uploadsHtml = () => {
    if (hasPrimyBookingForm) return '';
    const endpoint = bookingModal ? bookingModal.dataset.uploadEndpoint : '';
    const external = bookingModal ? bookingModal.dataset.externalUpload : '';
    if (!endpoint) {
      return `<div class="hnd-card hnd-card--border"><h3>${esc(bLabel('upload_pending_title', 'Upload connection pending'))}</h3><p>${esc(bLabel('upload_pending_text', 'File upload connection is pending. You can share floorplans, photos and moodboards after submitting your consultation request.'))}</p>${external ? `<a class="hnd-button" href="${external}" target="_blank" rel="noopener">${esc(bLabel('external_upload', 'Open External Upload Form'))}</a>` : ''}</div>`;
    }
    const inputs = parseConfiguredFields(bookingConfig.upload_fields, uploadFallback);
    return `<div class="hnd-upload-grid">${inputs.map((item) => {
      const multiple = item.type === 'multiple' ? 'multiple' : '';
      const required = item.required ? 'required' : '';
      return `<label class="hnd-upload-field"><span>${esc(item.label)}</span><input type="file" data-hnd-upload="${esc(item.label)}" accept=".jpg,.jpeg,.png,.webp,.pdf,.docx" ${multiple} ${required}><small>Accepted: JPG, PNG, WEBP, PDF and DOCX. Keep each file under the backend limit.</small></label>`;
    }).join('')}</div><p class="hnd-note">${esc(bLabel('upload_success_note', 'Files are sent to the configured upload endpoint before the booking payload is submitted. Use signed storage links in Make, Google Drive, Dropbox, Uploadcare or a custom endpoint.'))}</p>`;
  };

  const wishlistCategoryHtml = (category, items) => {
    const values = bookingState.wishlist_by_category[category] || {};
    return `<div class="hnd-wishlist-category"><h3>${esc(category)}</h3><div class="hnd-fields">${items.map((item) => {
      const saved = values[item.item] || {};
      const scope = item.scope || item.included_scope || '';
      return `<div class="hnd-wishlist-item hnd-field-full">
        <label>${esc(item.item)}<small>${esc(scope)}</small><select data-hnd-wishlist data-hnd-wish-category="${esc(category)}" data-hnd-wish-item="${esc(item.item)}" data-hnd-wish-key="selection"><option value="">Select option</option>${(item.options || []).map((option) => `<option value="${esc(option)}" ${saved.selection === option ? 'selected' : ''}>${esc(option)}</option>`).join('')}</select></label>
        <label>Preferred colour or finish<input type="text" maxlength="200" data-hnd-wishlist data-hnd-wish-category="${esc(category)}" data-hnd-wish-item="${esc(item.item)}" data-hnd-wish-key="finish" value="${esc(saved.finish || '')}"></label>
        <label>Upgrade request<select data-hnd-wishlist data-hnd-wish-category="${esc(category)}" data-hnd-wish-item="${esc(item.item)}" data-hnd-wish-key="upgrade"><option value="No" ${saved.upgrade !== 'Yes' ? 'selected' : ''}>No</option><option value="Yes" ${saved.upgrade === 'Yes' ? 'selected' : ''}>Yes</option></select></label>
        <label class="hnd-field-full">Notes<textarea rows="2" maxlength="1000" data-hnd-wishlist data-hnd-wish-category="${esc(category)}" data-hnd-wish-item="${esc(item.item)}" data-hnd-wish-key="notes">${esc(saved.notes || '')}</textarea></label>
      </div>`;
    }).join('')}</div></div>`;
  };

  const reviewHtml = () => {
    const pkg = packageData[bookingState.selected_package] || {};
    const detail = bookingState.personal_details || {};
    const apartment = bookingState.apartment_details || {};
    const wishlist = Object.entries(bookingState.wishlist_by_category || {}).map(([category, items]) => {
      const rows = Object.entries(items || {}).map(([item, value]) => {
        const selected = [value.selection, value.finish, value.upgrade === 'Yes' ? 'Upgrade requested' : '', value.notes].filter(Boolean).join(' | ');
        return `<li><strong>${esc(item)}:</strong> ${esc(selected || 'No selection')}</li>`;
      }).join('');
      return `<details open><summary>${esc(category)}</summary><ul>${rows}</ul></details>`;
    }).join('');
    const uploads = (bookingState.uploads_metadata || []).map((entry) => `<li>${esc(entry.field)}: ${esc((entry.files || []).map((file) => file.name).join(', ') || 'No file selected')}</li>`).join('');
    const uploadSummary = (hasPrimyBookingForm || bookingRuntime.projectId)
      ? `<li>${esc(bLabel('primy_upload_review', 'Project files are submitted through the secure Primy upload form.'))}</li>`
      : uploads || '<li>Upload connection pending or no files selected.</li>';
    return `<div class="hnd-review">
      <h3>Review your project brief</h3>
      <p><strong>Package:</strong> ${esc(pkg.name || bookingState.selected_package)} ${pkg.price ? `, ${esc(pkg.price)}` : ''}</p>
      <p><strong>Appointment:</strong> Booked through Calendly.</p>
      <p><strong>Customer:</strong> ${esc(detail.first_name || '')} ${esc(detail.last_name || '')}, ${esc(detail.email || '')}, ${esc(detail.whatsapp || '')}</p>
      <p><strong>Apartment:</strong> ${esc(apartment.community || '')} ${esc(apartment.building_name || '')} ${esc(apartment.apartment_type || '')}</p>
      <h4>Uploads</h4>
      <ul>${uploadSummary}</ul>
      <h4>Wishlist</h4>
      ${wishlist || '<p>No wishlist choices saved yet.</p>'}
      <label class="hnd-checkbox"><input type="checkbox" data-hnd-final-check required> ${esc(bLabel('confirm', 'I confirm the information is correct.'))}</label>
      <label class="hnd-checkbox"><input type="checkbox" data-hnd-final-check required> ${esc(bLabel('pending', 'I have booked my consultation through Calendly.'))}</label>
      <label class="hnd-checkbox"><input type="checkbox" data-hnd-final-check required> ${esc(bLabel('contact', 'I agree that Handovera may contact me about this project.'))}</label>
    </div>`;
  };

  const getSteps = () => {
    const groups = groupItems(wishlistData[bookingState.selected_package] || wishlistData.premium || []);
    const categorySteps = Object.keys(groups).map((category) => ({ type: 'wishlist', label: category, html: () => wishlistCategoryHtml(category, groups[category]) }));
    return [
      { type: 'package', label: bLabel('package_step', 'Confirm package'), html: () => `<div class="hnd-modal-packages">${['essential', 'premium', 'signature', 'royal'].map(packageCardHtml).join('')}</div>` },
      { type: 'details', label: bLabel('details_step', 'Personal and apartment details'), html: detailsHtml },
      ...categorySteps,
      { type: 'review', label: bLabel('review_step', 'Review and submit'), html: reviewHtml }
    ];
  };

  const collectFields = () => {
    qsa('[data-hnd-field]', bookingModal).forEach((input) => {
      const [group, name] = input.dataset.hndField.split('.');
      bookingState[group] = bookingState[group] || {};
      bookingState[group][name] = input.value;
    });
    qsa('[data-hnd-wishlist]', bookingModal).forEach((input) => {
      const category = input.dataset.hndWishCategory;
      const item = input.dataset.hndWishItem;
      const key = input.dataset.hndWishKey;
      if (!category || !item || !key) return;
      bookingState.wishlist_by_category[category] = bookingState.wishlist_by_category[category] || {};
      bookingState.wishlist_by_category[category][item] = bookingState.wishlist_by_category[category][item] || {};
      bookingState.wishlist_by_category[category][item][key] = input.value;
    });
    bookingState.uploads_metadata = qsa('[data-hnd-upload]', bookingModal).map((input) => ({
      field: input.dataset.hndUpload,
      files: Array.from(input.files || []).map((file) => ({ name: file.name, type: file.type, size: file.size }))
    })).filter((entry) => entry.files.length);
    saveDraft(bookingState);
  };

  const uploadBookingFiles = async (submissionId) => {
    if (hasPrimyBookingForm) return null;
    const endpoint = bookingModal ? bookingModal.dataset.uploadEndpoint : '';
    const inputs = qsa('[data-hnd-upload]', bookingModal).filter((input) => input.files && input.files.length);
    if (!endpoint || !inputs.length) return null;
    const formData = new FormData();
    formData.append('submission_id', submissionId);
    inputs.forEach((input) => Array.from(input.files).forEach((file) => {
      formData.append(safeId(input.dataset.hndUpload || 'file'), file, file.name);
    }));
    const response = await fetch(endpoint, { method: 'POST', body: formData });
    if (!response.ok) throw new Error('Upload failed');
    try { return await response.json(); } catch (error) { return { status: 'uploaded' }; }
  };

  const validateCurrent = () => {
    const invalid = qsa('input[required], select[required], textarea[required]', bookingModal).find((input) => !input.checkValidity());
    if (invalid) {
      invalid.reportValidity();
      return false;
    }
    return true;
  };

  const renderBookingStep = () => {
    if (!bookingModal) return;
    const steps = getSteps();
    if (bookingState.step >= steps.length) bookingState.step = steps.length - 1;
    const step = steps[bookingState.step];
    const mount = qs('[data-hnd-booking-step]', bookingModal);
    const title = qs('[data-hnd-booking-title]', bookingModal);
    const label = qs('[data-hnd-step-label]', bookingModal);
    const progressText = qs('[data-hnd-progress-text]', bookingModal);
    const progressBar = qs('[data-hnd-progress-bar]', bookingModal);
    const back = qs('[data-hnd-booking-back]', bookingModal);
    const next = qs('[data-hnd-booking-next]', bookingModal);
    if (title) title.textContent = step.label;
    if (label) label.textContent = `Step ${bookingState.step + 1} of ${steps.length}`;
    if (mount) mount.innerHTML = step.html();
    if (progressText) progressText.textContent = `${step.label}, ${Math.round(((bookingState.step + 1) / steps.length) * 100)}% complete`;
    if (progressBar) progressBar.style.width = `${Math.round(((bookingState.step + 1) / steps.length) * 100)}%`;
    if (back) back.hidden = bookingState.step === 0;
    if (next) next.textContent = bookingState.step === steps.length - 1 ? bLabel('submit', 'Send my project brief') : bLabel('next', 'Next');
    qsa('[data-hnd-modal-package]', bookingModal).forEach((button) => {
      button.addEventListener('click', () => {
        bookingState.selected_package = normalPackage(button.dataset.hndModalPackage);
        setSelectedPackage(bookingState.selected_package);
        saveDraft(bookingState);
        renderBookingStep();
      });
    });
  };

  const openBooking = (trigger) => {
    if (!bookingModal) return;
    const sidecar = Boolean(trigger && typeof trigger.hasAttribute === 'function' && trigger.hasAttribute('data-hnd-booking-sidecar'));
    const data = trigger && trigger.dataset ? trigger.dataset : {};
    bookingModal.classList.toggle('hnd-booking-modal--sidecar', sidecar);
    bookingState.selected_package = normalPackage(data.package || window.handoveraSelectedPackage || bookingState.selected_package);
    bookingState.selected_date = data.date || data.slot || bookingState.selected_date;
    bookingState.selected_time = data.time || data.slot || bookingState.selected_time;
    bookingState.step = 0;
    saveDraft(bookingState);
    renderBookingStep();
    showModal(bookingModal);
    const focusTarget = qs('button, input, select, textarea, a', bookingModal);
    if (focusTarget) focusTarget.focus();
  };

  const closeBooking = () => {
    if (!bookingModal) return;
    hideModal(bookingModal, collectFields);
    bookingRuntime.projectId = '';
    bookingRuntime.customerId = '';
    bookingRuntime.customerEmail = '';
    bookingRuntime.makeWebhook = '';
    window.setTimeout(() => bookingModal.classList.remove('hnd-booking-modal--sidecar'), 430);
  };

  qsa('[data-hnd-open-booking]').forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();
    openBooking(button);
  }));

  document.addEventListener('handovera:open-shopify-project-brief', (event) => {
    if (!bookingModal) return;
    const detail = event.detail || {};
    bookingRuntime.projectId = detail.projectId || '';
    bookingRuntime.customerId = detail.customerId || '';
    bookingRuntime.customerEmail = detail.email || '';
    bookingRuntime.makeWebhook = detail.makeWebhook || '';
    storageKey = projectStorageKey(bookingRuntime.projectId || bookingRuntime.customerId);
    const projectDraft = loadDraft();
    bookingState.personal_details = Object.assign({}, projectDraft.personal_details || {}, {
      first_name: detail.firstName || '',
      last_name: detail.lastName || '',
      email: detail.email || '',
      whatsapp: (projectDraft.personal_details || {}).whatsapp || ''
    });
    bookingState.apartment_details = projectDraft.apartment_details || {};
    bookingState.wishlist_by_category = projectDraft.wishlist_by_category || {};
    bookingState.uploads_metadata = [];
    bookingState.selected_date = projectDraft.selected_date || '';
    bookingState.selected_time = projectDraft.selected_time || '';
    bookingState.timezone = projectDraft.timezone || bookingModal.dataset.timezone || '';
    bookingState.tracking_data = projectDraft.tracking_data || {};
    bookingState.selected_package = normalPackage(detail.package || window.handoveraSelectedPackage || bookingState.selected_package);
    bookingState.step = 0;
    saveDraft(bookingState);
    openBooking({ dataset: { package: bookingState.selected_package }, hasAttribute: () => false });
  });

  if (bookingModal) {
    qsa('[data-hnd-close-booking]', bookingModal).forEach((button) => button.addEventListener('click', closeBooking));
    bookingModal.addEventListener('click', (event) => {
      if (event.target === bookingModal) closeBooking();
    });
    const back = qs('[data-hnd-booking-back]', bookingModal);
    const next = qs('[data-hnd-booking-next]', bookingModal);
    if (back) back.addEventListener('click', () => { collectFields(); bookingState.step = Math.max(0, bookingState.step - 1); renderBookingStep(); });
    if (next) next.addEventListener('click', async () => {
      if (!validateCurrent()) return;
      collectFields();
      const steps = getSteps();
      if (bookingState.step < steps.length - 1) {
        bookingState.step += 1;
        renderBookingStep();
        return;
      }
      const checks = qsa('[data-hnd-final-check]', bookingModal);
      if (checks.some((check) => !check.checked)) { setStatus(bLabel('required_checks', 'Please confirm all required statements before submitting.')); return; }
      const webhook = bookingRuntime.makeWebhook || bookingModal.dataset.webhook;
      if (!webhook) { setStatus(bLabel('backend_missing', 'Booking backend is not connected yet.')); return; }
      const submissionId = `handovera_${Date.now()}`;
      let upload_result = null;
      if (!bookingRuntime.projectId) {
        try {
          upload_result = await uploadBookingFiles(submissionId);
        } catch (error) {
          setStatus(bLabel('upload_failed', 'File upload failed. Check the upload endpoint before submitting.'));
          return;
        }
      }
      const payload = {
        event_type: 'questionnaire.submitted.v1',
        submission_id: submissionId,
        created_at: new Date().toISOString(),
        project_id: bookingRuntime.projectId,
        shopify_customer_id: bookingRuntime.customerId,
        selected_package: bookingState.selected_package,
        selected_date: bookingState.selected_date,
        selected_time: bookingState.selected_time,
        timezone: bookingState.timezone,
        personal_details: bookingState.personal_details,
        apartment_details: bookingState.apartment_details,
        uploads_metadata: bookingState.uploads_metadata,
        upload_result,
        wishlist_by_category: bookingState.wishlist_by_category,
        customer_email: bookingState.personal_details.email,
        customer_whatsapp: bookingState.personal_details.whatsapp,
        source_page: window.location.pathname,
        tracking_data: bookingState.tracking_data,
        document_request: {
          format: 'pdf',
          file_name: `${bookingRuntime.projectId || submissionId}-project-brief.pdf`,
          source: 'questionnaire'
        }
      };
      try {
        if (!window.HandoveraProjectBriefPdf || typeof window.HandoveraProjectBriefPdf.create !== 'function') {
          throw new Error('Project brief PDF generator is unavailable');
        }
        payload.document = window.HandoveraProjectBriefPdf.create(payload);
      } catch (error) {
        setStatus(bLabel('pdf_failed', 'Your project brief PDF could not be created. Please refresh and try again.'));
        return;
      }
      const serializedPayload = JSON.stringify(payload);
      if (new Blob([serializedPayload]).size > maxQuestionnairePayloadBytes) {
        setStatus(bLabel('payload_too_large', 'Your project brief is too large to submit. Reduce long notes and try again.'));
        return;
      }
      setStatus(bLabel('submitting', 'Submitting your project brief.'));
      try {
        const response = await fetch(webhook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: serializedPayload });
        if (!response.ok) throw new Error('Webhook failed');
        setStatus(bLabel('submitted', 'Your project brief has been received. Continue with the secure file upload below.'));
        localStorage.removeItem(storageKey);
        document.dispatchEvent(new CustomEvent('handovera:questionnaire-submitted', {
          detail: { projectId: bookingRuntime.projectId, submissionId }
        }));
      } catch (error) {
        setStatus(bLabel('failed', 'Your project brief could not be submitted. Please try again or contact Handovera.'));
      }
    });
  }

  const networkModal = qs('[data-hnd-network-modal]');
  const networkConfig = readJson('[data-hnd-network-config]') || {};
  const networkLabels = networkConfig.labels || {};
  const nLabel = (key, fallback) => networkLabels[key] || fallback;
  const networkFields = {
    contractor: String(networkConfig.contractor || '').split(/\n+/).map((line) => line.trim()).filter(Boolean),
    supplier: String(networkConfig.supplier || '').split(/\n+/).map((line) => line.trim()).filter(Boolean),
    partner: String(networkConfig.partner || '').split(/\n+/).map((line) => line.trim()).filter(Boolean)
  };
  if (!networkFields.contractor.length) networkFields.contractor = ['Company name','Contact person','Email','WhatsApp','Country','Dubai license status','Trade category','Years active','Team size','Service areas','Project types completed','Insurance status','Certifications','Portfolio upload','Project photos upload','Trade license upload','Certificates upload','References available yes or no','Average lead time','Capacity per month','Goal of cooperation','Services offered','Why do you want to work with Handovera','Notes'];
  if (!networkFields.supplier.length) networkFields.supplier = ['Company name','Contact person','Email','WhatsApp','Supplier category','Product range','Brands carried','Stock location','Dubai delivery capability','Assembly capability','Lead times','Trade pricing available yes or no','Warranty terms','Catalog upload','Product photos upload','Certificates upload','Trade license upload','Website or catalog link','Minimum order value','Payment terms','Goal of cooperation','What can you offer Handovera','Notes'];
  if (!networkFields.partner.length) networkFields.partner = ['Name','Company','Role','Email','WhatsApp','Partner type','Dubai license or RERA number if applicable','Client type','Main communities served','Estimated referrals per month','Preferred partnership model','Upload company profile','Upload license or certificate','Goal of cooperation','What type of clients can you refer','What do you expect from Handovera','Notes'];

  const renderNetworkFields = (type) => {
    const mount = qs('[data-hnd-network-fields]', networkModal);
    if (!mount) return;
    mount.innerHTML = (networkFields[type] || networkFields.contractor).map((label) => {
      const key = safeId(label);
      const isUpload = label.toLowerCase().includes('upload');
      if (isUpload && networkModal.dataset.uploadEndpoint) return `<label class="hnd-upload-field"><span>${esc(label)}</span><input type="file" name="${key}" accept=".jpg,.jpeg,.png,.webp,.pdf,.docx" multiple><small>Accepted: JPG, PNG, WEBP, PDF and DOCX. Files must be processed by the connected secure upload endpoint.</small></label>`;
      if (isUpload) return `<label>${label}<input type="text" name="${key}" placeholder="${esc(nLabel('upload_placeholder', 'Upload connection pending. Paste link if available.'))}"></label>`;
      if (label === 'Notes' || label.includes('Why') || label.includes('What')) return `<label class="hnd-field-full">${label}<textarea name="${key}" rows="3"></textarea></label>`;
      const required = ['Email', 'WhatsApp', 'Company name', 'Contact person', 'Name'].includes(label);
      return `<label>${label}<input type="${label === 'Email' ? 'email' : 'text'}" name="${key}" ${required ? 'required' : ''}></label>`;
    }).join('');
  };

  const openNetwork = (type) => {
    if (!networkModal) return;
    const selected = normalPackage(type || 'contractor');
    const cleanType = ['contractor', 'supplier', 'partner'].includes(selected) ? selected : 'contractor';
    const typeField = qs('[data-hnd-network-type]', networkModal);
    const title = qs('[data-hnd-network-title]', networkModal);
    if (typeField) typeField.value = cleanType;
    if (title) title.textContent = nLabel(`${cleanType}_title`, `${cleanType.charAt(0).toUpperCase()}${cleanType.slice(1)} application`);
    renderNetworkFields(cleanType);
    showModal(networkModal);
    const focusTarget = qs('button, input, select, textarea, a', networkModal);
    if (focusTarget) focusTarget.focus();
  };

  qsa('[data-hnd-open-network]').forEach((button) => button.addEventListener('click', () => openNetwork(button.dataset.networkType)));
  if (networkModal) {
    const closeNetwork = () => hideModal(networkModal);
    qsa('[data-hnd-close-network]', networkModal).forEach((button) => button.addEventListener('click', closeNetwork));
    networkModal.addEventListener('click', (event) => {
      if (event.target === networkModal) closeNetwork();
    });
    const form = qs('[data-hnd-network-form]', networkModal);
    if (form) form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = qs('[data-hnd-network-status]', networkModal);
      const webhook = networkModal.dataset.webhook;
      if (!webhook) { if (status) status.textContent = nLabel('backend_missing', 'Network registration backend is not connected yet.'); return; }
      const data = Object.fromEntries(new FormData(form).entries());
      const payload = { submission_id: `handovera_network_${Date.now()}`, created_at: new Date().toISOString(), registration_type: data.registration_type, fields: data, tracking_data: { source_page: window.location.pathname } };
      try {
        const response = await fetch(webhook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        if (!response.ok) throw new Error('Webhook failed');
        if (status) status.textContent = nLabel('submitted', 'Application submitted.');
      } catch (error) {
        if (status) status.textContent = nLabel('failed', 'Submission failed. Check the network webhook.');
      }
    });
  }

  const calendar = qs('[data-hnd-calendar]');
  if (calendar && calendar.dataset.endpoint) {
    fetch(calendar.dataset.endpoint).then((response) => response.ok ? response.json() : null).then((data) => {
      if (!data || !Array.isArray(data.slots)) return;
      const grid = qs('[data-hnd-slot-grid]', calendar);
      if (!grid) return;
      grid.innerHTML = data.slots.map((slot) => `<button class="hnd-slot" type="button" data-hnd-open-booking data-event="calendar_slot_selected" data-slot="${slot.label || slot.time}" data-date="${slot.date || ''}" data-time="${slot.time || ''}"><span>${slot.label || slot.time}</span><small>${slot.detail || ''}</small></button>`).join('');
      qsa('[data-hnd-open-booking]', grid).forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); openBooking(button); }));
    }).catch(() => {});
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (bookingModal && !bookingModal.hidden && bookingModal.classList.contains('is-open')) closeBooking();
    if (networkModal && !networkModal.hidden && networkModal.classList.contains('is-open')) hideModal(networkModal);
    if (processModal && !processModal.hidden && processModal.classList.contains('is-open')) hideModal(processModal);
    if (projectModal && !projectModal.hidden && projectModal.classList.contains('is-open')) hideModal(projectModal);
  });
})();
